// Mock data for Plantinha de Geladeira B2B Landing Page

export const whatsappNumber = "5511941651849";
export const whatsappMessage = "Olá, vim dos anúncios do Google e quero um orçamento de brindes corporativos para empresa/evento";

// URL completa do WhatsApp
export const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

// Função para rastrear conversão e abrir WhatsApp
export const trackAndOpenWhatsApp = () => {
  // Dispara conversão do Google Ads
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11077389987/cPCkCKfg36AcEKOdjqIp'
    });
    console.log('✅ Conversão Google Ads rastreada!');
  }

  // Aguarda 300ms e abre WhatsApp
  setTimeout(() => {
    window.location.href = whatsappURL;
  }, 300);
};

export const heroData = {
  title: "Presente corporativo personalizado, que gera EMOÇÃO e CONECTA",
  subtitle: "Enquanto brindes comuns são esquecidos, sua marca continua presente no dia a dia do cliente e do colaborador",
  cta: "Solicitar Orçamento",
  features: [
  "✓ Sustentável, criativo e com impacto social",
  "✓ Personalização com logo da empresa",
  "✓ Entrega em todo o Brasil",
  "✓ Pedidos a partir de 20 unidades",
  "✓ Desconto progressivo por volume",
  "✓ Prazo médio de produção: 15 dias",
  "✓ Personalize com botton ou sublimação"]

};

export const aboutData = {
  title: "Quem Somos",
  description: "A Plantinha de Geladeira nasceu para levar natureza, cor e afeto de forma prática ao dia a dia. Um presente criativo, sustentável e 100% brasileiro, ideal para ações corporativas, brindes personalizados e campanhas que conectam marcas de forma memorável.",
  highlight: "Destaque no programa Mais Você com Ana Maria Braga"
};

export const benefitsData = [
{
  icon: "Users",
  title: "Versatilidade",
  description: "Presente criativo, ideal para eventos, onboarding, relacionamento, branding e reconhecimento 🎁"
},
{
  icon: "Award",
  title: "Memorável",
  description: "Produto diferente de tudo que você já viu, duradouro e que fixa sua marca na rotina do presenteado 📌"
},
{
  icon: "Heart",
  title: "Impacto Emocional",
  description: "Acompanhar uma plantinha crescer gera conexão genuína, apego e cria memória afetiva ❤️"
},
{
  icon: "Package",
  title: "Criado para Conectar",
  description: "Produto inteligente que une design, natureza e experiência do usuário ⬡"
},
{
  icon: "TrendingUp",
  title: "Produto com Propósito",
  description: "Produção nacional, colaborativa e com impacto social positivo 🇧🇷"
},
{
  icon: "Leaf",
  title: "Sustentabilidade",
  description: "Produto sustentável que fortalece o compromisso da empresa com o meio ambiente ♻️"
}];


export const useCasesData = {
  title: "Soluções para Sua Empresa",
  cases: [
  {
    title: "Eventos Corporativos",
    description: "Palestras, convenções, feiras e workshops",
    image: "https://images.unsplash.com/photo-1766853209032-3c4b7a5c8b04"
  },
  {
    title: "Brindes para Clientes",
    description: "Fidelização e fortalecimento de relacionamento",
    image: "https://images.unsplash.com/photo-1686771416282-3888ddaf249b"
  },
  {
    title: "Kits de Colaboradores",
    description: "Onboarding, aniversários e reconhecimento",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216"
  },
  {
    title: "Grandes Redes de Varejo",
    description: "Revenda com margem atrativa",
    image: "https://images.unsplash.com/photo-1765739100184-7bd5aa8f75b7"
  }]

};

export const clientLogos = [
{ name: "Globo", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/j9bk1xah_C%C3%B3pia%20de%20C%C3%B3pia%20de%20Design%20sem%20nome%20%281%29.png" },
{ name: "Udemy", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/9jwu76oi_1.jpg" },
{ name: "Dentsply Sirona", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/ejtv6t08_2.jpg" },
{ name: "LG", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/3fsbfec4_3.jpg" },
{ name: "RENASE Eventos", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/xeuzhq2x_4.jpg" },
{ name: "BLINDEX", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/8yiqge4c_5.jpg" },
{ name: "Chave Ideal", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/5cudcck6_C%C3%B3pia%20de%20C%C3%B3pia%20de%20Design%20sem%20nome.png" },
{ name: "SOPI", logo: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/lc1525r3_C%C3%B3pia%20de%20C%C3%B3pia%20de%20Design%20sem%20nome%20%281%29.jpg" }];


export const mediaHighlight = {
  title: "Todos os dias há 4 anos na geladeira mais famosa do Brasil!",
  subtitle: "Desde 2022 no Programa Mais Você com Ana Maria Braga",
  videoUrl: "https://youtu.be/MX8NqDMogqA",
  thumbnail: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/kscphob5_maxresdefault.jpg",
  description: "🌱 Desde 2022, a Plantinha de Geladeira faz parte da rotina do programa Mais Você, da icônica Ana Maria Braga! Todos os dias, levando vida, cor e natureza para um dos programas mais queridos do Brasil."
};

export const testimonialsData = [
{
  text: "As Plantinhas de Geladeira foram o brinde perfeito para nosso evento anual. Todos os participantes adoraram!",
  author: "Maria Silva",
  company: "Diretora de Marketing - Tech Corp",
  rating: 5
},
{
  text: "Produto sustentável e de qualidade. Nossos colaboradores ficaram encantados com o mimo no kit de boas-vindas.",
  author: "João Santos",
  company: "RH - Startup Innovation",
  rating: 5
},
{
  text: "Excelente custo-benefício para grandes volumes. Atendimento profissional e entrega pontual.",
  author: "Ana Costa",
  company: "Compradora - Rede de Varejo Nacional",
  rating: 5
}];


export const faqData = [
{
  question: "Qual o pedido mínimo para empresas?",
  answer: "Atendemos pedidos corporativos a partir de 20 unidades."
},
{
  question: "Posso personalizar com a identidade da minha empresa?",
  answer: "Sim! Personalize com botton e/ou sublimação direto no cachepot. Escolha a embalagem ideal e receba o presente pronto 🎁"
},
{
  question: "Qual o prazo de entrega?",
  answer: "Temos cores e embalagens à pronta entrega. Para pedidos personalizados, o prazo médio de produção é de 15 dias. Programe seu presente com antecedência. Produzimos em volume e entregamos conforme a sua demanda."
},
{
  question: "As plantas são de verdade?",
  answer: "Sim! Trabalhamos com suculentas reais, cultivadas por produtores independentes e cuidadosamente selecionadas. Isso garante plantas saudáveis, bonitas e cultivadas com atenção desde o primeiro dia. 🌱"
},
{
  question: "Como solicitar um orçamento?",
  answer: "Preencha o formulário e receba uma proposta personalizada por e-mail. Ou, se preferir, fale conosco agora mesmo pelo WhatsApp."
}];


export const socialLinks = {
  instagram: "https://instagram.com/plantinhadegeladeira",
  whatsapp: `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`
};

export const galleryData = [
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/7x2qif0z_01%20embalagem.JPG",
  title: "Sacola Kraft Natural",
  description: "Embalagem sustentável e reutilizável, com ou sem personalização"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/x9nerdnz_02%20embalagem.JPG",
  title: "Bolsa com Visor",
  description: "Personalize a cor da alça de acordo com sua identidade visual"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/gzeu97l4_03%20embalagem.png",
  title: "Caixa Reciclada Cartonado Premium",
  description: "Embalagem em cores variadas com laço personalizado"
}];

// Carrossel extra (acima dos logos) — imagens trocáveis independentemente
export const extraGalleryData = [
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/xpp6bk9s_SOPI.2.jpeg",
  title: "Sopi - Embalagem Premium",
  description: "Sacolas brancas com laço rosa personalizadas Sopi"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/xx59fh8g_SOPI3.jpeg",
  title: "Sopi - Plantinhas Personalizadas",
  description: "Vasinhos hexagonais rosa com logo Sopi"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/u2u734x2_SQUAD%201.jpg",
  title: "Squad Capital - Presente Executivo",
  description: "Sacola branca com fita azul e plantinha personalizada Squad"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/h3mlazkt_SQUAD%202.png",
  title: "Squad Capital - Plantinhas Azuis",
  description: "Vasinhos hexagonais azul royal personalizados Squad"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/smcfhp9p_UDEMY.PRINCIPAL.JPG",
  title: "Udemy - Painel Plantado",
  description: "Logo da Udemy formado por plantinhas em um painel corporativo"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/75fsbgo4_LG5%20%281%29.jpeg",
  title: "LG - Life's Good",
  description: "Vasinhos vermelhos e brancos personalizados com logo LG e Life's Good"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/1sx376ao_PALMEIRAS.1%20%281%29.jpeg",
  title: "Palmeiras - Palestra Itália",
  description: "Plantinha personalizada com escudo histórico do Palestra Itália"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/f99z8niq_RENASE%201%20%281%29.jpeg",
  title: "Renase - Destaques do Ano 2025",
  description: "Vasinhos roxos personalizados para o Prêmio Renase"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/eso7ezu6_RENASE.PRINCIPAL%20%281%29.jpg",
  title: "Renase - Painel Obrigado",
  description: "Painel evento Renase formado por plantinhas escrevendo OBRIGADO"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/yg3zm8oh_SER.PALESTRINO1%20%281%29.jpeg",
  title: "Ser Palestrino + Plantinha de Geladeira",
  description: "Kit de presente Palmeiras com sacola rosa Plantinha de Geladeira"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/s8ht95cz_BLINDEX.1.jpeg",
  title: "Blindex - Transparência com Elas",
  description: "Vasinhos vermelhos com plantinha e cartão da 5ª edição Blindex"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/xycfx9jh_Dentsply%20Sirona1.jpeg",
  title: "Dentsply Sirona - Embalagem Premium",
  description: "Plantinha em vaso preto com sacola branca e fita azul personalizada"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/s3vfoag0_IMG_4940%202%20%281%29.jpeg",
  title: "Squad Capital - Detalhes do Presente",
  description: "Plantinhas Squad Capital prontas para entrega corporativa"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/wycuplxt_LG%203%20%281%29.JPG",
  title: "LG - Caixa Kraft Premium",
  description: "Caixa kraft com laço vermelho e botton LG personalizado"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/pbsa8oie_LG%204%20%281%29.jpeg",
  title: "LG - Feliz Dia das Mães",
  description: "Cartão Feliz Dia das Mães com sacola personalizada Plantinha LG"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/y6m8nfrd_BEAT0%202.jpeg",
  title: "Beato - Painel Amarelo",
  description: "Painel completo de plantinhas em vasinhos amarelos personalizados Beato"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/b0mc2gq3_BEATO1.png",
  title: "Beato - Presente Executivo",
  description: "Plantinha Beato em vaso amarelo ao lado de sacola personalizada"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/rjh4q91b_BLINDEX%202.JPEG",
  title: "Blindex - Plantinha Vermelha",
  description: "Suculenta espinhosa em vasinho vermelho personalizado Blindex"
}];


export const brandCasesData = [
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/cvax4xpm_1.png",
  brand: "Sublimação em todas as cores"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/zwuvpo2a_2.png",
  brand: "Plantinhas decorando a geladeira"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/50n9scnb_3.png",
  brand: "Plantinha verde personalizada"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/v3wpiy6w_4.png",
  brand: "Geladeira decorada com plantinhas"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/9rwhmhqy_5.png",
  brand: "Compromisso com economia sustentável"
},
{
  image: "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/t07i4j0l_6.png",
  brand: "Plantinha artesanal na bag de tricô"
}];